<template>
    <div :style="{ height: videoHeightStyle }" class="d-flex flex-column">
        <div :id="videoIdSanitized" class="w-100 flex-grow-1 embedded-video"></div>
    </div>
</template>

<script>
import YouTubePlayer from "youtube-player"
import Utilities from "@/assets/js/utilities.js"

export default {
    name: "EmbeddedVideo",
    props: {
        // The Youtube video ID.
        videoId: {
            type: String,
            required: false,
        },
        videoUrl: {
            type: String,
            required: false,
        },
        height: {
            type: Number,
            default: 320,
        },
        fullHeight: {
            type: Boolean,
            default: false,
        },
        fullScreen: {
            type: Boolean,
            default: false
        },
        autoplay: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            player: null,
            videoIdSanitized: null,
        }
    },
    computed: {
        videoHeightStyle() {
            return this.fullHeight ? "100%" : this.height + "px"
        },
    },
    methods: {
        // Initialize the embedded YouTube video.
        initializeEmdeddedYT() {
            // Extract the video ID from the provided URL if a video ID isn't provided.
            if (this.videoId) {
                this.videoIdSanitized = this.videoId
            } else {
                this.videoIdSanitized = this.extractVideoIdFromUrl(this.videoUrl)
            }
            let vm = this
            // Wait for the element to be rendered before initializing the player.
            this.$nextTick(() => vm.initYTPlayer())
        },
        initYTPlayer() {
            // Initialize the player.
            this.player = YouTubePlayer(this.videoIdSanitized, {
                videoId: this.videoIdSanitized,
                playerVars: {
                    autoplay: 0,
                    controls: 1,
                    rel: 0,
                    fs: 1,
                    color: "white",
                    modestbranding: 1,
                    origin: window.location.origin,
                    playsinline: 1,
                },
            })

            if (this.autoplay) {
                this.player.playVideo()
            }

            let vm = this
            this.player.on("ready", (event) => {
                // Enter full screen if flag is set.
                if (vm.fullScreen) {
                    let player = document.getElementById(this.videoIdSanitized)
                    Utilities.enterFullScreen(player)
                }
            })

            this.player.on("stateChange", (event) => {
                if (event.data === 0) {
                    this.$emit("video-finished", true)
                    this.videoComplete = true
                    // Exit full screen.
                    if (vm.fullScreen) {
                        Utilities.exitFullScreen()
                    }
                }
            })
        },
        // Restart the video.
        restart() {
            this.$emit("video-restart")
            this.player.playVideo()
        },
        // Extract the youtube video ID from a full URL.
        extractVideoIdFromUrl(src) {
            let videoID = ""
            if (src.includes("embed/")) {
                // Source is an embed url.
                videoID = src.split("embed/")[1]
            } else if (src.includes("v=")) {
                // Source is a direct link to a youtube video.
                videoID = src.split("v=")[1]
            } else if (src.includes("youtu.be/")) {
                videoID = src.split("youtu.be/")[1]
            } else {
                // Assume src is a youtube video ID.
                videoID = src
            }
            return videoID
        },
        skipVideo() {
            let vm = this
            this.player.getDuration().then(function(duration) {
                vm.player.seekTo(duration, true)
            })
        },
    },
    watch: {
        videoId() {
            this.$nextTick(function () {
                this.initializeEmdeddedYT()
            })
        },
    },
    mounted() {
        this.initializeEmdeddedYT()
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.embedded-video {
    overflow: hidden;
}
</style>